var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { right: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-layout",
                _vm._g(
                  {
                    staticStyle: { "flex-wrap": "nowrap" },
                    attrs: { row: "", "align-center": "" }
                  },
                  on
                ),
                [
                  _c(
                    "v-icon",
                    { attrs: { color: _vm.getColor(_vm.state.main_color) } },
                    [_vm._v("\n        check_circle\n      ")]
                  ),
                  _vm._v(" "),
                  _vm.state.secondary_warning
                    ? _c(
                        "v-icon",
                        {
                          attrs: {
                            color: _vm.getColor(
                              _vm.state.secondary_warning_color
                            )
                          }
                        },
                        [_vm._v("\n        priority_high\n      ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.tooltip))])]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d2469f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2469f5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssetReservationManagement/Data/StateIcon.vue
// module id = null
// module chunks = 